import SigningService from '@/modules/signers/services/signingService'
import Signature from '@/models/Signature'

export default {
  namespaced: true,
  state: () => {
    return {
      dialogWizard: false,
      dialogFinish: false,
      token: null,
      documentId: null,
      signerId: null,
      signerRfc: null,
      signature: null,
      step: 1,
      steps: [
        { id: 1, title: 'Documento', component: 'ViewerPDF' },
        { id: 2, title: 'Validar identidad', component: 'FielValidatorInline' },
        { id: 3, title: 'Firmar', component: 'SigningReview' }
      ],
      onSuccessSigning: null
    }
  },
  mutations: {
    SET_STEP(state, step) {
      state.step = step
    },
    SET_DIALOG_WIZARD(state, dialog) {
      state.dialogWizard = dialog
    },
    SET_DIALOG_FINISH(state, finish) {
      state.dialogFinish = finish
    },
    SET_TOKEN(state, token) {
      state.token = token
    },
    SET_DOCUMENT_ID(state, documentId) {
      state.documentId = documentId
    },
    SET_SIGNER_ID(state, signerId) {
      state.signerId = signerId
    },
    SET_ON_SUCCESS_SIGNING(state, callback) {
      state.onSuccessSigning = callback
    }
  },
  actions: {
    openWizard({ commit }) {
      commit('SET_STEP', 1)
      commit('SET_DIALOG_WIZARD', true)
    },
    closeWizard({ commit }) {
      commit('SET_DIALOG_WIZARD', false)
      commit('SET_DIALOG_FINISH', false)
      commit('SET_TOKEN', null)
      commit('SET_DOCUMENT_ID', null)
      commit('SET_SIGNER_ID', null)
    },
    finishWizard({ commit }) {
      commit('SET_DIALOG_FINISH', true)
    },
    goNext({ commit, state }) {
      if (state.step < state.steps.length) {
        commit('SET_STEP', state.step + 1)
      }
    },
    goBack({ commit, state }) {
      if (state.step > 1) {
        commit('SET_STEP', state.step - 1)
      }
    },
    setTokenWizard({ commit }, token) {
      commit('SET_TOKEN', token)
    },
    setDocumentWizard({ commit }, document) {
      commit('SET_DOCUMENT_ID', document)
    },
    setSignerWizard({ commit }, signer) {
      commit('SET_SIGNER_ID', signer)
    },
    async getDocumentMetadata({ state }) {
      const service = new SigningService()
      return service.documentMetadata(state.token, state.documentId)
    },
    async signDocument({ state }, data) {
      const signatureObj = new Signature(
        data.fiel._publicCertificate,
        data.fiel._privateKey,
        data.fiel._passwordPrivateKey
      )
      const signature = await signatureObj.signature(data.file)

      if (signature == null) {
        return new Promise(reject => {
          reject({
            success: false,
            errorMessage: 'No se pudo generar la firma'
          })
        })
      }

      const dataParam = {
        idFirmante: state.signerId,
        idDocumento: state.documentId,
        certificado: data.fiel._publicCertificate,
        signature: signature
      }

      const service = new SigningService()
      return service.signedDocumentService(state.token, dataParam)
    },
    setOnSuccessSigning({ commit }, callback) {
      commit('SET_ON_SUCCESS_SIGNING', callback)
    }
  },
  getters: {
    dialogWizard(state) {
      return state.dialogWizard
    },
    dialogFinish(state) {
      return state.dialogFinish
    },
    steps(state) {
      return state.steps
    },
    wizardLength(state) {
      return state.steps.length
    },
    canGoNext(state, getters, rootState) {
      switch (state.step) {
        case 1:
          return rootState.viewerPDFStore.ok
        case 2:
          return rootState.fielStorage.isValid
        case 3:
          return true
      }
    },
    wizardStep(state) {
      return state.step
    },
    tokenWizard(state) {
      return state.token
    },
    documentWizard(state) {
      return state.documentId
    },
    signerWizard(state) {
      return state.signerId
    },
    onSuccessSigning(state) {
      return state.onSuccessSigning
    }
  }
}
